import { css } from 'styled-components';

export const AuroraSkin = css`
  background-color: #3194b3;
  border: 5px solid #fff;
  box-shadow: 0 0 4px inset #3194b3;
`;

export const AuroraWrapperSkin = css`
  background: #6e6e6e;
  background: radial-gradient(circle, rgb(66, 91, 108) 0%, rgb(3, 17, 28) 100%);
`;

export const AuroraLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#fff' : '#000')};
  text-shadow: ${props => (props.$isActive ? 'none' : '2px 2px 3px rgba(255,255,255,0.5)')};
  opacity: ${props => (props.$isActive ? 1 : 0.1)};
`;
